interface SectionBadgeProps {
  children: React.ReactNode
  className?: string
}

export default function SectionBadge({ children, className = "" }: SectionBadgeProps) {
  return <div className={`inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.08em] text-muted-foreground ${className}`}>{children}</div>
}
